import { render, staticRenderFns } from "./o-list-offices.vue?vue&type=template&id=0bdb27e2"
import script from "./o-list-offices.vue?vue&type=script&lang=js"
export * from "./o-list-offices.vue?vue&type=script&lang=js"
import style0 from "./o-list-offices.vue?vue&type=style&index=0&id=0bdb27e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports